export * as Api from './api';

export enum TaxReliefDisplayMode {
  Actual = 'ACTUAL',
  Forecast = 'FORECAST',
}
export enum CompanyBreakdownDisplayMode {
  SeparateTab = 'SEPARATE-TAB',
  UnderSummaryTable = 'UNDER-SUMMARY-TABLE',
}

export enum TileType {
  SUBSCRIPTIONS = 'subscription',
  MOIC = 'MOIC',
  MULTIPLE = 'multiple',
  DISTRIBUTABLE = 'distributable',
  HELD_BY_MANAGER_AWAITING_INVESTMENT = 'held-by-manager-awaiting-investment',
}

export enum InvestmentIdentifierDisplayMode {
  ExternalInvestmentId = 'EXTERNAL_INVESTMENT_ID',
  SubscriptionDate = 'SUBSCRIPTION_DATE',
}

export enum ShowSubscriptionPagePerformanceChartMode {
  Always = 'ALWAYS',
  Never = 'NEVER',
  AfterDeployment = 'AFTER_DEPLOYMENT',
}

export interface WithdrawalFee {
  amount?: number | null;
  vat?: number | null;
  rangeStart?: number | null;
  rangeEnd?: number | null;
}

export enum SyndicatesArrangement {
  TaxYear = 'taxYear',
  CalendarYear = 'calendarYear',
  All = 'all',
}

export interface PermittedClassifications {
  everyday: boolean;
  sophisticated: boolean;
  highNetWorth: boolean;
  professional: boolean;
}
